class OverflowSwitcher {
	constructor(show) {
		this.show = show;
		this.isOpen = false;

		this.init();
	}

	init() {
		this.isOpen = this.modalIsOpen();
		this.overflowSwitcher(this.isOpen);
	}

	modalIsOpen() {
		const modalList = document.querySelectorAll("[data-modal-overflow]");
		const array = [];
        
		if (modalList) {
			const uniqArray = [...new Set([...modalList])];

			uniqArray.forEach((item) => {
				if (item && (item.classList.contains("show") || item.checked === true || item.hasAttribute("open")) && !array.includes(item.classList.value)) {
					array.push(item.classList.value);
				}
			});
			
			return array.length > 0;
		}
	}

	overflowSwitcher(isOpen) {
		new StickyNormalizer(isOpen);

		if (isOpen) {
			const scrollBarWidth = window.scrollBarWidth;

			document.body.style.marginRight = `${scrollBarWidth}px`;
			document.documentElement.marginRight = `${scrollBarWidth}px`;
		} else {
			document.body.style.marginRight = '0';
			document.documentElement.marginRight = '0';
		}

		document.documentElement.style.overflow = isOpen ? "hidden" : "";
		document.body.style.overflow = isOpen ? "hidden" : "";

		if (this.show === true) {
			new StickyNormalizer(true);

			document.body.style.marginRight = `0`;
			document.documentElement.style.marginRight = "0";
			
			document.documentElement.style.overflow = "";
			document.body.style.overflow = "";
		}
	}
}